import type { TFunction } from 'i18next';
import type { DirTaskCategoryType, TaskTypeDirType } from '@econtractor/types';
import { tDirName } from 'utils/helpers/i18n/tDirName';
import { TASK_FILTER_STATUSES, type FilterOption } from '../model/types';

type TranslateFn = (key: string) => string;

export const toTypeOptions = (
    types: TaskTypeDirType[] | undefined,
    t: TFunction,
): FilterOption[] =>
    (types || []).map((tt) => ({
        value: Number(tt.ID),
        label: tDirName(t, tt.i18nKey, tt.taskTypeName) || String(tt.taskTypeName || tt.ID),
        kind: 'type' as const,
        icon: tt.taskTypeIcon || null,
        colors: tt.taslTypeJson || null,
    }));

export const toCategoryOptions = (categories: DirTaskCategoryType[] | undefined): FilterOption[] =>
    (categories || [])
        .filter((item) => !item.hidden)
        .map((item) => ({
            value: Number(item.ID),
            label: String(item.categoryName || item.ID),
            kind: 'category' as const,
        }));

export const toStatusOptions = (t: TranslateFn, excludeSet: Set<number> | null): FilterOption[] =>
    TASK_FILTER_STATUSES.filter((statusId) => !excludeSet?.has(statusId)).map((statusId) => ({
        value: statusId,
        label: t(`status.${statusId}`),
        kind: 'status' as const,
    }));
